import React, { useMemo } from 'react';
import CreateExclusionJobButton from './CreateExclusionJobButton';
import {
  useEmailExclusionJobSubscription,
  useListEmailExclusionJobs,
} from 'query/acg/phase-1';
import { ListEmailExclusionJobsResponse } from './types';
import UserWithAvatar from 'components/ui/UserWithAvatar';
import moment from 'moment/moment';
import ReactTable from 'react-table';
import TablePagination from 'components/ui/TablePagination';
import EmailExclusionJobStatus from './components/EmailExclusionJobStatus';
import ViewExclusionJobDetailsButton from './ViewExclusionJobDetailsButton';

const columnDefs = [
  {
    id: 'ID',
    Header: 'ID',
    accessor: 'id',
    maxWidth: 60,
  },
  {
    id: 'totalExclusionFiles',
    Header: 'Num of Exclusion Files',
    headerStyle: { justifyContent: 'center', display: 'flex' },
    style: { justifyContent: 'center', display: 'flex' },
    accessor: row => row.exclusionFiles.length,
  },
  {
    id: 'totalCampaignFiles',
    Header: 'Num of Campaign Files',
    headerStyle: { justifyContent: 'center', display: 'flex' },
    style: { justifyContent: 'center', display: 'flex' },
    accessor: row => row.campaignFiles.length,
  },
  {
    id: 'createdBy',
    Header: 'Started By',
    accessor: row => <UserWithAvatar user={row.createdBy} />,
  },
  {
    id: 'status',
    Header: 'Status',
    headerStyle: { justifyContent: 'center', display: 'flex' },
    maxWidth: 150,
    accessor: row => {
      return <EmailExclusionJobStatus job={row} />;
    },
  },
  {
    id: 'createdAt',
    headerStyle: { justifyContent: 'center', display: 'flex' },
    style: { justifyContent: 'center', display: 'flex' },
    Header: 'Created At',
    accessor: row => moment(row.createdAt).format('YYYY-MM-DD HH:mm'),
  },
  {
    id: 'updatedAt',
    headerStyle: { justifyContent: 'center', display: 'flex' },
    style: { justifyContent: 'center', display: 'flex' },
    Header: 'Updated At',
    accessor: row => moment(row.updatedAt).format('YYYY-MM-DD HH:mm'),
  },
  {
    id: 'actions',
    Header: '',
    accessor: row => <ViewExclusionJobDetailsButton job={row} />,
  },
];

export default function EmailExclusion() {
  useEmailExclusionJobSubscription();
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(10);
  const { data, isLoading, isFetching } = useListEmailExclusionJobs(
    page,
    limit,
  );
  const { data: jobs = [], users = {}, total }: ListEmailExclusionJobsResponse =
    data || {};
  const jobsWithUsers = useMemo(() => {
    return jobs.map(job => {
      const user = users[job.createdBy] || {};
      return {
        ...job,
        createdBy: user,
      };
    });
  }, [jobs, users]);
  return (
    <>
      <CreateExclusionJobButton />
      <ReactTable
        PaginationComponent={TablePagination}
        columns={columnDefs}
        data={jobsWithUsers}
        defaultPageSize={10}
        indexKey="id"
        loading={isLoading || isFetching}
        manual
        minRows={0}
        nextText={<i className="material-icons">chevron_right</i>}
        page={page - 1}
        pageSize={limit}
        pageSizeOptions={[5, 10, 15, 20]}
        pages={Math.ceil(total / limit)}
        previousText={<i className="material-icons">chevron_left</i>}
        rowsSelectorText="Rows per page"
        showPageJump={false}
        showPageSizeOptions
        showPaginationBottom
        style={{ marginTop: 16 }}
        onPageChange={pageIndex => setPage(pageIndex + 1)}
        onPageSizeChange={pageSize => {
          setPage(1);
          setLimit(pageSize);
        }}
      />
    </>
  );
}
